module.exports = __webpack_public_path__ + "img/logo_ue_fse.49dff232.png";